import React from 'react';
import { Modal, Field } from './ui';

const MODES = ['Existing User', 'New User'];

// Super Admin quick "New Event" dialog from the top bar - phone: full screen,
// a two-button Existing / New user switch, number pad for the mobile, Create
// at the bottom.
export default function NewEventModalMobile({ vm }) {
  const { closeEventModal, eventForm, setEventField, eventTypeOptions, userOptions, savingEvent, addEvent } = vm;
  const mode = eventForm.EventAdminMode || 'Existing User';
  return (
    <Modal
      title="New Event"
      fullScreen
      className="ev-m"
      onClose={closeEventModal}
      footer={<>
        <button className="btn light" type="button" onClick={closeEventModal}>Cancel</button>
        <button className="btn primary" type="button" disabled={savingEvent} onClick={addEvent}>
          {savingEvent ? 'Creating...' : 'Create'}
        </button>
      </>}
    >
      <Field label="Event Name" value={eventForm.EventName} onChange={(v) => setEventField('EventName', v)} required />
      <Field label="Event Type" type="select" value={eventForm.EventTypeId} options={eventTypeOptions} onChange={(v) => setEventField('EventTypeId', v)} required />

      <div className="field">Event Admin *
        <div className="ev-seg" role="group" aria-label="Event Admin" style={{ marginTop: 4 }}>
          {MODES.map(m => (
            <button key={m} type="button" className={mode === m ? 'on' : ''} style={{ padding: '11px 6px', fontSize: 14 }}
              onClick={() => setEventField('EventAdminMode', m)}>{m}</button>
          ))}
        </div>
      </div>

      {mode === 'New User' ? (
        <>
          <Field label="New User Name" value={eventForm.EventAdminName} onChange={(v) => setEventField('EventAdminName', v)} required />
          <div className="ev-m-pair">
            <label className="field">Mobile *
              <input type="tel" inputMode="numeric" value={eventForm.EventAdminMobileNumber ?? ''} placeholder="10 digits"
                onChange={(e) => setEventField('EventAdminMobileNumber', e.target.value)} />
            </label>
            <label className="field">Password
              <input value={eventForm.EventAdminPassword ?? ''} onChange={(e) => setEventField('EventAdminPassword', e.target.value)} />
            </label>
          </div>
        </>
      ) : (
        <Field label="Existing User" type="select" value={eventForm.EventAdminUserId} options={userOptions} onChange={(v) => setEventField('EventAdminUserId', v)} required />
      )}
    </Modal>
  );
}
